import cx from 'classnames'
import type React from 'react'

import { GtmTriggerName, sendGtmEvent } from '@/constants/gtm'
import type { Comment } from '@/types/models'
import { SearchEntity } from '../../hooks/useSearch'
import css from '../../Result.module.scss'

type Props = {
  comments: Record<string, Comment>
  selectedItemId: string | null
  onClick: (entity: SearchEntity, payload: any) => void
  hideTitle?: boolean
}

const Comments: React.FC<Props> = ({
  comments,
  selectedItemId,
  onClick,
  hideTitle,
}) => {
  const handleClick = (comment: Comment) => () => {
    sendGtmEvent(GtmTriggerName.SEARCH_RESULT_CLICK, 'Comment result clicked')
    sendGtmEvent(GtmTriggerName.SEARCH_COMMENT_CLICK, 'Comment result clicked')
    onClick(SearchEntity.COMMENT, comment)
  }

  return (
    <div>
      {Object.keys(comments).length > 0 && (
        <div>
          {!hideTitle && <div className={css.title}>Comments</div>}

          <div className={css.list}>
            {Object.entries(comments).map(([id, comment]) => (
              <div
                key={comment.id}
                className={cx(css.item, {
                  [css.selected]: selectedItemId === id,
                })}
                onClick={handleClick(comment)}
              >
                <div>{comment.content}</div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}

export default Comments
